import React from "react";
import Select from "react-select";

const SelectField = ({
  height = "50px",
  onChange,
  value,
  name = "",
  options,
}) => {
  const styles = {
    control: (styles, { isFocused, isSelected }) => ({
      ...styles,
      border: "1px solid rgba(0, 0, 0, 0.15)",
      outline: isFocused && "none",
      boxShadow: "none",
      minHeight: height,
      height: height,
      margin: 0,
      backgroundColor: "transparent",
      ":hover": {
        outline: "none",
        border: "1px solid rgba(0, 0, 0, 0.15)",
      },
      padding: 0,
    }),
    menu: (provided, state) => ({
      ...provided,
      border: "none",
      backgroundColor: "#fff",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
      border: "none",
      color: "#000",
      fontSize: "8px",
      fontWeight: 500,
      backgroundColor: "transparent",
    }),
    input: (styles) => ({
      ...styles,
      padding: 0,
      margin: 0,
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: "0 8px",
    }),
  };
  return (
    <div>
      <Select
        // className="basic-single"
        classNamePrefix="select"
        value={value}
        // isDisabled={isDisabled}
        onChange={onChange}
        isClearable={false}
        isSearchable={true}
        styles={styles}
        name={name}
        options={options ?? []}
      />
    </div>
  );
};

export default SelectField;
